/**
 * Cart
 **/
app.add({

    init: function(app){
        app.cart2 = this;
    },

    onLoad: function(){
        $('.form--cart2 select[name="country"], .form--cart2 select.item-quantity').each(function(){
            this.addEventListener('change', app.cart2);
            app.cart2.handleEvent({target: this});
        });
        app.notify('cart2Load');
    },

    items: {},
    total: 0,
    country: 'US',
    xhr: null,

    handleEvent: function(e){
        if (/item-quantity/.test(e.target.className)) {
            this.setProduct(e.target);
        } else {
            this.setShipping(e.target.value);
        }
        this.updateTotal();
    },

    count: function(){
        var l = 0;
        for (var i in this.items){
            l += this.items[i].qty;
        }
        return l;
    },

    setProduct: function(product){
        this.items[product.getAttribute('data-product-id')] = parseInt(product.value);
    },

    updateTotal: function(){
        var data = {
          'item': this.items,
          'country': this.country,
          'order': 'v2'
        };

        if (this.xhr) {
          this.xhr.abort();
          this.xhr = null;
        }

        this.xhr = $.post(window.shopOrderDetailsUrl, data, function(response){
          if (! response.order) return;
          var order = response.order;
          $('.form--cart2 .item-total').each(function(){
            var value = $(this).parents('tr').find('.item-quantity').attr('data-product-price');
            var cost = value ? parseInt(value, 10) : 0;
            $(this).text('$'+cost.toFixed(2)).removeClass('text-black').addClass('text-lightgrey');
          });
          for (var itemKey in order.costs) {
            var cost = order.costs[itemKey];
            $('.form--cart2 .item-total-id-'+itemKey).text('$'+cost.toFixed(2)).removeClass('text-lightgrey').addClass('text-black');
          }
          $('.form--cart2 .shipping-costs-total').text('$'+order.shipping.toFixed(2))[order.shipping > 0 ? 'addClass' : 'removeClass']('text-black');
          $('.form--cart2 .total').text('$'+order.total.toFixed(2));
        });
    },

    setShipping: function(country){
      this.country = country;
    }

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/cart2.js